import {
  InternalApiTransactionRelatedPerson,
  InternalApiTransactionRelatedPersonCategory,
  InternalApiTransactionRelatedPersonType,
} from '../api-internal';

export const isBusinessPerson = (person: InternalApiTransactionRelatedPerson) =>
  [InternalApiTransactionRelatedPersonType.BUSINESS, InternalApiTransactionRelatedPersonType.LEGAL].includes(
    person.type
  );

export const isIndividualPerson = (person: InternalApiTransactionRelatedPerson) =>
  [InternalApiTransactionRelatedPersonType.PRIVATE, InternalApiTransactionRelatedPersonType.INDIVIDUAL].includes(
    person.type
  );

export const isCounterpartyPerson = (person: InternalApiTransactionRelatedPerson) =>
  InternalApiTransactionRelatedPersonCategory.COUNTERPARTY === person.category;
